/*
window.addEventListener('load', function () {
  let anchorlinks = document.querySelectorAll('a[href^="#"]');

  for (let item of anchorlinks) {
    item.addEventListener('click', (e) => {
      let hashval = item.getAttribute('href');
      let target = document.querySelector(hashval);
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      history.pushState(null, null, hashval);
      e.preventDefault();
    });
  }
});
*/

window.data = () => {
  return {
    mobile: window.innerWidth < 768,
    active: '',
    timeout: null,
    debounce(func, wait) {
      let later = function () {
        this.timeout = null;
        func.apply(this, []);
      };
      clearTimeout(this.timeout);
      this.timeout = setTimeout(later, wait);
    },
  };
};
